import { useHttpClient } from "@/common/api/httpClient";
import { useTranslations } from "shared/translations/composables/useTranslations";
import { ref } from "vue";

export function useMoveTimberFromLogSorterBinsApi() {
  const httpClient = useHttpClient();
  const translations = useTranslations();
  const loading = ref<boolean>(false);

  return {
    execute,
    loading
  };

  async function execute() {
    try {
      loading.value = true;
      const headers = httpClient.defaultHeaders();
      const request = new Request(httpClient.siteUrl('move/moveTimberFromLogSorterBins'), {
        method: 'POST',
        headers
      });

      const text = translations.value.moves.actions.moveTimberFromLogSorterBins;

      const response = await httpClient.action(request, {
        title: text.title,
        errorTitle: text.error,
        async processOk() {
          return {
            ok: true
          };
        },
      });

      return response;
    } finally {
      loading.value = false;
    }
  }
}
